export { SearchLegacy } from './SearchLegacy'
export type { SearchLegacyProps } from './types'
